export default __webpack_public_path__ + "static/media/colage-movies.18fe30f7.jpg";